import { ref } from 'vue';
import type { ArrayElementType } from '@/core/types/gengeric';
import { useServices } from '@/core/composables/services';
import {
  EdiType,
  ESignatureStatus,
  type GetDocumentsQuery,
  MutationResult,
  useGetDocumentToSignQuery,
  useSaveDocumentSignatureMutation,
} from '@/graphql/generated';
import { useGetDocumentsQuery } from '@/graphql/generated';
import { GetDocumentLink } from '@/parts/documents/gql/documents';

export type DocumentsType = GetDocumentsQuery['documents'];
export type DocumentsItemType = ArrayElementType<DocumentsType>;

const documents = ref<DocumentsType>([]);

export const useDocumentsStore = () => {
  const { $api } = useServices();

  const getDocuments = async () => {
    const { request, data, response, errors } = useGetDocumentsQuery({});

    await request();

    if (!errors.value && data.value) {
      documents.value = data.value.documents;
    }

    return response;
  };

  const getDocumentLink = (documentId: string, ediType: EdiType) =>
    $api.query<{ getDocumentLink: { data: Blob } }>(GetDocumentLink, { documentId, ediType });

  const getDocumentToSign = async (documentId: string) => {
    const { request } = useGetDocumentToSignQuery({ documentId });

    const response = await request();

    return response;
  };

  const saveDocumentSignature = async (documentId: string, signature: string) => {
    const { request } = useSaveDocumentSignatureMutation({ documentId, signature });

    const response = await request();

    if (response.data?.saveDocumentSignature.mutationResult === MutationResult.Success) {
      const doc = documents.value.find((doc) => doc.documentId === documentId);

      if (doc) {
        doc.signatureStatus = ESignatureStatus.MutuallySigned;
      }
    }

    return response;
  };

  return {
    documents,

    getDocuments,
    getDocumentLink,
    getDocumentToSign,
    saveDocumentSignature,
  };
};
